module.exports = __webpack_public_path__ + "img/gifRoute.c37a1465.gif";